import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=47b10df6&scoped=true"
import script from "./AvatarCropper.vue?vue&type=script&lang=js"
export * from "./AvatarCropper.vue?vue&type=script&lang=js"
import style0 from "./AvatarCropper.vue?vue&type=style&index=0&id=47b10df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b10df6",
  null
  
)

export default component.exports